/**
 * Create Data Bins context for custom hook
 */

import { createContext } from 'react'

const DisableCheckoutsContext = createContext({
  fetchDisableCheckouts: () => {},
  fetchDisableCheckoutsAll: () => {}
})

export default DisableCheckoutsContext
